import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="dropdown"
export default class extends Controller {
	static values = {
		open: false,
		contentBreite: Number,
	}
	static targets = ["button", "content"]

	connect() {
		// Content positionieren
		this.contentBreiteValue = this.contentTarget.offsetWidth
		this.contentTarget.classList.add("hidden")

		// Transition Classes zum Content Target hinzufügen
		this.contentTarget.setAttribute("data-transition-enter", "transition ease-out duration-100")
		this.contentTarget.setAttribute("data-transition-enter-start", "transform opacity-0 scale-95")
		this.contentTarget.setAttribute("data-transition-enter-end", "transform opacity-100 scale-100")
		this.contentTarget.setAttribute("data-transition-leave", "transition ease-in duration-75")
		this.contentTarget.setAttribute("data-transition-leave-start", "transform opacity-100 scale-100")
		this.contentTarget.setAttribute("data-transition-leave-end", "transform opacity-0 scale-95")

		// Im Button die Toogle Action hinzufügen
		if (this.buttonTarget.dataset.value == "prevent") {
			// Braucht man nur für das Dropdown der Kapitalanlagen (Zwischenlösung)
			this.buttonTarget.dataset.action = "click->dropdown#toggle:prevent"
		} else if (this.buttonTarget.dataset.value == "datepicker") {
			// Der Datepicker soll immer nur aufgehen
			this.buttonTarget.dataset.action = "click->dropdown#open"
		} else {
			this.buttonTarget.dataset.action = "click->dropdown#toggle"
		}
	}

	toggle() {
		// console.log("dropdown#toggle")
		if (this.openValue) {
			this.close()
		} else {
			this.open()
		}
	}

	closeByClick(event) {
		// Wenn das Dropdown nicht offen ist braucht es nicht geschlossen werden
		if (!this.openValue) return

		// Click auf den Button ignorieren
		if (this.buttonTarget.contains(event.target)) return

		// Click innerhalb des Contents des Dropdowns ignorieren
		if (this.contentTarget.contains(event.target)) return

		this.close()
	}

	closeByFocusOut() {
		// Es braucht ein setTimeout damit ein weiteres Feld den Focus bekommen kann bevor der Check ausgeführt wird
		setTimeout(() => {
			if (!this.openValue) return
			const inputs = this.contentTarget.querySelectorAll("input[type=text]")

			// Überprüfen, ob ein Eingabefeld den Fokus hat
			const isInputFocused = Array.from(inputs).some((input) => input === document.activeElement)

			// Wenn kein Eingabefeld den Fokus hat, das Dropdown schließen
			if (!isInputFocused) this.close()
		}, 50)
	}

	open() {
		// Wenn es schon offen ist braucht es nicht noch einmal geöffnet werden
		if (this.openValue) return

		this.openValue = true
		this.buttonTarget.dataset.ui = "aktiv"

		enter(this.contentTarget)

		// Das braucht man bei dem Besitzer Formular, damit man direkt eingeben kann
		const inputElement = this.contentTarget.querySelector("input[type=text]")
		if (inputElement) inputElement.focus()
	}

	close() {
		this.openValue = false
		leave(this.contentTarget)
		this.buttonTarget.removeAttribute("data-ui")
	}
}
